import BundleOfferTilePricing from 'components/OfferList/OfferListTiles/Support/BundleOfferTilePricing'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { useDirectSearchPrices } from 'hooks/Search/useSearchPrices'
import useBestPriceBundleAndSavePackage from 'hooks/useBestPriceBundleAndSavePackage'
import { EmptyArray } from 'lib/array/arrayUtils'
import { EmptyObject } from 'lib/object/objectUtils'
import { hasDisplayablePackagePrice } from 'lib/offer/pricingVisibility'
import useHotelSearchPriceAlignment from 'hooks/Experiments/useHotelSearchPriceAlignment'

interface Props {
  offer: App.BundleOffer
  filters?: App.OfferListFilters
  offerMetaData: App.BundleOfferListMetaData
  hidePrice?: boolean
}

function HotelBundleSearchTilePricePoint({
  offer,
  filters,
  offerMetaData,
  hidePrice,
}: Props) {
  const alignWithPriceBlockExperiment = useHotelSearchPriceAlignment()
  const directSearchPrices = useDirectSearchPrices({ filters: filters ?? EmptyObject, offerId: offer.id })
  const {
    bestPricePackage,
  } = useBestPriceBundleAndSavePackage(offer, offerMetaData.bundledOfferId, filters, directSearchPrices, offerMetaData)

  const offerUrl = useOfferUrl(offer, {
    filters,
    bundledOfferId: offerMetaData?.bundledOfferId,
    offerLinkIncludesFilters: true,
  })

  if (!bestPricePackage || !hasDisplayablePackagePrice(bestPricePackage)) return null

  return <BundleOfferTilePricing
    align={alignWithPriceBlockExperiment ? 'right' : undefined}
    offer={offer}
    rooms={filters?.rooms ?? EmptyArray}
    offerAvailable={!!offerMetaData.available}
    pkg={bestPricePackage}
    filters={filters}
    offerUrl={offerUrl}
    hidePrice={hidePrice}
  />
}

export default HotelBundleSearchTilePricePoint
